import { render } from "./RetirerAgentPage.vue?vue&type=template&id=a09d7360&ts=true"
import script from "./RetirerAgentPage.vue?vue&type=script&lang=ts"
export * from "./RetirerAgentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__